import { render, staticRenderFns } from "./PubGroupSubsection.vue?vue&type=template&id=3954bd31&scoped=true"
import script from "./PubGroupSubsection.vue?vue&type=script&lang=js"
export * from "./PubGroupSubsection.vue?vue&type=script&lang=js"
import style0 from "./PubGroupSubsection.vue?vue&type=style&index=0&id=3954bd31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../imported/work/site/src/project/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954bd31",
  null
  
)

export default component.exports